import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import TabsMenu from "../components/TabsMenu";
import {WHITE_LABEL_LOGO_URL} from '../utils/EnvVars';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  grow: {
    flexGrow: 1,    
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },  
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export default function Header(props) {
   
  const classes = useStyles();
 
  

  return (<>
    <div className={classes.grow} >
      <AppBar position="fixed" className={classes.appBar} >

        <Toolbar>
                 
          <span className={classes.sectionDesktop} >
                {
                (window.location.hostname==='localhost' || window.location.hostname==='uat.easetolearn.com' || window.location.hostname==='easetolearn.com')?
                <img src={process.env.PUBLIC_URL+"/ease_to_learn_logo.png"} style={{height:37,marginRight:35}}  />
                :<img src={WHITE_LABEL_LOGO_URL+'/'+window.location.hostname.replace(/\./g,'-')+'.png'} style={{height:37,marginRight:35}}  />
                }
          </span>

          <div className={classes.grow} />          
          
        </Toolbar>
      </AppBar>
      <div className={classes.sectionMobile} ><TabsMenu /></div>     
    </div>    

    

  </>);
}